import { useState } from 'react'
import { accountService } from '../../../../service/AccountService'
import { showSuccessToast, showErrorToast } from '../../../../utils/showToast'
import { mapUserData } from '../hooks/useGetAccount'
import { GET_ALL_USER_SIZE } from '../../../../data/queryFactories'
import { useMutation } from '@tanstack/react-query'
import { useParseQuery } from '../../../../hooks/useNav'

export default function useSelectAccounts() {
  const { queryParams } = useParseQuery()
  const [selectedAccount, setSelectedAccount] = useState(new Map())
  const [selectAll, setSelectAll] = useState(false)
  const [newStatusCount, setNewStatusCount] = useState({
    ACTIVE: 0,
    INACTIVE: 0,
  })

  const resetSelectAccount = () => {
    setSelectedAccount(new Map())
    setSelectAll(false)
    setNewStatusCount({ ACTIVE: 0, INACTIVE: 0 })
  }

  const toggleSelectAccount = (account) => {
    setSelectedAccount((oldMap) => {
      const newAccMap = new Map(oldMap)
      if (newAccMap.has(account.id)) {
        newAccMap.delete(account.id)
        setNewStatusCount((prev) => ({
          ...prev,
          [account.status]: prev[account.status] - 1,
        }))
      } else {
        newAccMap.set(account.id, account)
        setNewStatusCount((prev) => ({
          ...prev,
          [account.status]: prev[account.status] + 1,
        }))
      }
      return newAccMap
    })
  }
  const getAllAccountsMutation = useMutation({
    mutationFn: async () => {
      const result = await accountService.search({
        ...queryParams,
        pageNumber: 0,
        pageSize: GET_ALL_USER_SIZE,
      })

      if (!result.success) {
        throw new Error('Không xác định')
      }

      if (!result.message?.content?.users) {
        throw new Error('Không tìm thấy dữ liệu người dùng')
      }

      const userList = result.message.content.users.map((item) =>
        mapUserData(item)
      )

      const counts = userList.reduce(
        (acc, curr) => {
          if (curr.status === 'ACTIVE') {
            acc.ACTIVE += 1
          } else {
            acc.INACTIVE += 1
          }
          return acc
        },
        { ACTIVE: 0, INACTIVE: 0 }
      )

      const selectedAccounts = userList.reduce((acc, curr) => {
        acc.set(curr.id, curr)
        return acc
      }, new Map())

      return {
        selectedAccounts,
        statusCounts: counts,
      }
    },
    onError: (error) => {
      showErrorToast({
        error: error.message,
        message: 'Lấy thông tin thất bại vui lòng liên hệ admin',
      })
    },
    onSuccess: (data) => {
      showSuccessToast('Chọn tất cả tài khoản thành công')
      setSelectedAccount(data.selectedAccounts)
      setNewStatusCount(data.statusCounts)
    },
  })
  const toggleSelectAll = async () => {
    if (!selectAll) {
      getAllAccountsMutation.mutate()
      setSelectAll(true)
    } else {
      resetSelectAccount()
    }
  }

  return {
    selectedAccount,
    selectAll,
    newStatusCount,
    toggleSelectAccount,
    toggleSelectAll,
    resetSelectAccount,
  }
}
